/* ORILIS — motion layer. Reveals on scroll, rotating text rings, map + timeline triggers,
   photo auto-slide, number count-up. Skips movement when the visitor prefers reduced motion. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canIO = 'IntersectionObserver' in window;
  if (!reduce && canIO) document.documentElement.classList.add('o-motion');

  function onView(els, cb, opts) {
    if (!canIO) { els.forEach(cb); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { cb(e.target); io.unobserve(e.target); } });
    }, opts || { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  var REVEAL = [
    '.o-sec .o-wrap > .o-h2', '.o-sec .o-wrap > .o-badge', '.o-sec .o-wrap > .o-lead', '.o-sec .o-wrap > .o-rte',
    '.o-sec .o-wrap > .o-media', '.o-sec .o-wrap > .o-pivot', '.o-sec .o-wrap > .o-btn', '.o-sec .o-wrap > .o-safety',
    '.o-sec .o-center > *', '.o-checks > li', '.o-benefit', '.o-step', '.o-ing', '.o-numlist > li', '.o-review',
    '.o-cmp__head > *', '.o-faq details', '.o-map__copy > *', '.o-photos__slide', '.o-trust__item', '.o-seal-wrap'
  ].join(',');

  function initReveal(root) {
    if (reduce || !canIO) return;
    var els = Array.prototype.slice.call((root || document).querySelectorAll(REVEAL))
      .filter(function (el) { return !el.closest('.o-pdp') && !el.classList.contains('o-rv'); });
    els.forEach(function (el) {
      var sibs = Array.prototype.filter.call(el.parentNode.children, function (c) { return els.indexOf(c) > -1; });
      el.style.setProperty('--d', Math.min(sibs.indexOf(el), 6));
      el.classList.add('o-rv');
    });
    onView(els, function (el) { el.classList.add('is-in'); });
  }

  var uid = 0;
  function ring(text, size, icon) {
    uid += 1;
    var id = 'o-ring-' + uid, r = size / 2 - 9;
    return '<svg class="o-ring" viewBox="0 0 ' + size + ' ' + size + '" aria-hidden="true" data-r="' + r + '">' +
      '<defs><path id="' + id + '" d="M ' + size / 2 + ',' + size / 2 + ' m -' + r + ',0 a ' + r + ',' + r + ' 0 1,1 ' + 2 * r + ',0 a ' + r + ',' + r + ' 0 1,1 -' + 2 * r + ',0"/></defs>' +
      '<text><textPath href="#' + id + '">' + text + ' · </textPath></text></svg>' + (icon || '');
  }
  function fitRing(svg) {
    var tp = svg.querySelector('textPath'); if (!tp || !tp.getComputedTextLength) return;
    var unit = tp.textContent, one = tp.getComputedTextLength(); if (!one) return;
    var circ = 2 * Math.PI * parseFloat(svg.getAttribute('data-r'));
    var n = Math.max(1, Math.floor(circ / one));
    tp.textContent = unit.repeat(n);
    var gap = (circ - one * n) / (unit.length * n);
    if (gap > 0) tp.setAttribute('letter-spacing', Math.min(gap, 2).toFixed(2));
  }
  var LEAF = '<span class="o-ring__core"><svg class="o-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 19c0-8 5-13 14-14 0 9-5 14-13 14H5zm0 0 8-8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

  function initRings(root) {
    (root || document).querySelectorAll('.o-gal__badge:not(.o-ringed)').forEach(function (b) {
      var t = b.textContent.trim(); if (!t) return;
      b.classList.add('o-ringed'); b.setAttribute('aria-label', t);
      b.innerHTML = ring(t, 104, LEAF); fitRing(b.querySelector('.o-ring'));
    });
    (root || document).querySelectorAll('.o-seal').forEach(function (s) {
      if (s.parentNode.classList.contains('o-seal-wrap')) return;
      var h = s.closest('.o-wrap') && s.closest('.o-wrap').querySelector('.o-h2');
      var t = (s.getAttribute('data-ring') || (h ? h.textContent.trim() : 'ORILIS'));
      var w = document.createElement('div'); w.className = 'o-seal-wrap';
      s.parentNode.insertBefore(w, s); w.innerHTML = ring(t, 190); w.appendChild(s); fitRing(w.querySelector('.o-ring'));
    });
  }

  function countUp(el) {
    var end = parseInt(el.textContent, 10); if (!end || reduce) return;
    var t0 = null, dur = 1200;
    function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur); el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(step); }
    el.textContent = '0'; requestAnimationFrame(step);
  }

  function initTriggers(root) {
    var r = root || document;
    onView(Array.prototype.slice.call(r.querySelectorAll('[data-o-map], .o-tl, .o-cmp')), function (el) {
      el.classList.add('is-in');
      el.querySelectorAll('.o-map__points strong').forEach(function (s) { if (/^\d+$/.test(s.textContent.trim())) countUp(s); });
    }, { threshold: 0.3 });
  }

  function initSlides(root) {
    (root || document).querySelectorAll('[data-o-autoslide]').forEach(function (track) {
      if (track.dataset.oInit) return; track.dataset.oInit = '1';
      var slides = track.children, dots = track.parentNode.querySelectorAll('.o-photos__dots span');
      var every = (parseInt(track.dataset.oAutoslide, 10) || 0) * 1000, paused = false, timer;
      function index() {
        var best = 0, min = Infinity, box = track.getBoundingClientRect();
        for (var i = 0; i < slides.length; i++) { var d = Math.abs(slides[i].getBoundingClientRect().left - box.left); if (d < min) { min = d; best = i; } }
        if (document.documentElement.dir === 'rtl') { min = Infinity; for (var j = 0; j < slides.length; j++) { var e = Math.abs(slides[j].getBoundingClientRect().right - box.right); if (e < min) { min = e; best = j; } } }
        return best;
      }
      function paint() { var i = index(); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }
      function go(i) { var s = slides[i]; if (!s) return; track.scrollTo({ left: s.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingInlineStart || 0), behavior: reduce ? 'auto' : 'smooth' }); }
      function tick() {
        if (paused || document.hidden) return;
        var atEnd = Math.abs(track.scrollLeft) + track.clientWidth >= track.scrollWidth - 4;
        go(atEnd ? 0 : index() + 1);
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
      ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) { track.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['pointerleave', 'focusout'].forEach(function (ev) { track.addEventListener(ev, function () { paused = false; }); });
      paint();
      if (every > 0 && !reduce) timer = setInterval(tick, every);
    });
  }

  function initAll(root) { initRings(root); initReveal(root); initTriggers(root); initSlides(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); e.target.querySelectorAll('.o-rv').forEach(function (el) { el.classList.add('is-in'); }); });
})();
